import { render } from "./index.vue?vue&type=template&id=1bc85078"
const script = {}
script.render = render

export default script